export default function isAppOutdated(currentVersion: string) {
  try {
    return fetch(`/meta.json?preventCache=${new Date()}`)
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        );

        return shouldForceRefresh;
      });
  } catch (e) {
    console.warn('version check failed to run.', e);
    return Promise.resolve(true);
  }
}

const semverGreaterThan = (latestVersion: string, currentVersion: string) => {
  if (
    !latestVersion ||
    !currentVersion ||
    latestVersion === 'undefined' ||
    currentVersion === 'undefined'
  ) {
    return false;
  }

  const latestArray = latestVersion.split(/\./g);
  const currentArray = currentVersion.split(/\./g);

  while (currentArray.length || latestArray.length) {
    const a = Number(latestArray.shift());
    const b = Number(currentArray.shift());

    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }

  return false;
};
